import { BaseChart } from '@/components/Charts';

interface Series {
  name?: string;
  data: { y: number; color?: string }[];
}

interface BarChartProps {
  title: string;
  series: Series[];
  categories: string[];
  customColors?: string[];
  hasTotal?: boolean;
  headerTooltip?: string;
  formatValue?: (val: number) => string;
}

export const BarChart = ({
  customColors,
  formatValue,
  ...rest
}: BarChartProps) => {
  return (
    <BaseChart
      chartType="bar"
      formatValue={formatValue}
      customOptions={{
        ...(customColors ? { colors: customColors } : {}),
        plotOptions: {
          bar: {
            borderRadius: 0,
          },
        },
      }}
      {...rest}
    />
  );
};
